'use client';

/* eslint-disable @next/next/no-img-element -- SVG service icons render directly inside Swiper slides without responsive image optimization. */
import { A11y, Keyboard } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { HOME_SOLUTIONS } from './home-solutions-data';

export function HomeSolutionsSwiper() {
  return (
    <Swiper
      modules={[A11y, Keyboard]}
      slidesPerView="auto"
      spaceBetween={16}
      grabCursor
      keyboard={{ enabled: true }}
      watchOverflow
      className="!overflow-visible"
      aria-label="Ship Smart transportation solutions"
    >
      {HOME_SOLUTIONS.map((solution) => (
        <SwiperSlide
          key={solution.title}
          className="!h-auto !w-[min(86vw,390px)] md:!w-[min(43vw,480px)]"
        >
          <article className="!flex !h-full !min-h-[320px] !flex-col !rounded-[20px] !border !border-white/15 !bg-[#0c2344] !p-6 !text-white md:!min-h-[390px] md:!p-8 lg:!min-h-[420px] lg:!p-12">
            <h4 className="!mb-8 !text-[22px] !font-semibold !leading-[1.2] !tracking-[-0.02em] md:!text-[24px] lg:!text-[26px]">
              {solution.title}
            </h4>

            <img
              src={solution.icon}
              alt=""
              width={64}
              height={64}
              loading="lazy"
              decoding="async"
              className="!mb-10 !h-14 !w-14 !object-contain !brightness-0 !invert md:!h-16 md:!w-16"
            />

            <p className="!mb-0 !mt-auto !max-w-[25rem] !text-[17px] !leading-[1.45] !text-white/85 md:!text-[20px] lg:!text-[22px]">
              {solution.description}
            </p>
          </article>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
